/**
 * Resolve optional PBR companion maps next to an albedo path.
 *
 * albedo:  images/textures/wood/vagonka/foo.jpg
 * normal:  images/textures/wood/vagonka/foo_nrm.jpg
 * rough:   images/textures/wood/vagonka/foo_rgh.jpg
 * ao:      images/textures/wood/vagonka/foo_ao.jpg  (optional)
 *
 * Explicit obj.normalMap / obj.roughnessMap / obj.aoMap win if provided.
 */

export function pbrCompanionPaths( albedoPath, overrides = {} ) {

  if ( !albedoPath || typeof albedoPath !== 'string' ) {

    return {

      normalMap: overrides.normalMap || null,
      roughnessMap: overrides.roughnessMap || null,
      aoMap: overrides.aoMap || null,

    };

  }

  // Already a generated companion — don't nest suffixes
  if ( /_(nrm|rgh|ao|col)\.(jpe?g|png|webp)$/i.test( albedoPath ) ) {

    return {

      normalMap: overrides.normalMap || null,
      roughnessMap: overrides.roughnessMap || null,
      aoMap: overrides.aoMap || null,

    };

  }

  const stem = albedoPath.replace( /\.(jpe?g|png|webp)$/i, '' );

  return {

    normalMap: overrides.normalMap || `${ stem }_nrm.jpg`,
    roughnessMap: overrides.roughnessMap || `${ stem }_rgh.jpg`,
    aoMap: overrides.aoMap || `${ stem }_ao.jpg`,

  };

}

/**
 * Load a texture; resolve(null) if 404 / error (so albedo-only still works).
 */
export function loadTextureOptional( url, TextureLoader, THREE ) {

  return new Promise(( resolve ) => {

    if ( !url ) {

      resolve( null );
      return;

    }

    const loader = new TextureLoader();

    loader.load(
      url,
      ( texture ) => resolve( texture ),
      undefined,
      () => resolve( null )
    );

  });

}
